/**
 * @generated SignedSource<<a1e60efc92252fb84ccc45a9fa399200>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateWebFormSubmissionInput = {
  answers?: ReadonlyArray<WebFormAnswerInput> | null;
  contentUsageId?: string | null;
  webFormRevisionId: string;
};
export type WebFormAnswerInput = {
  body?: string | null;
  isSkipped?: boolean | null;
  selectedOptions?: ReadonlyArray<string> | null;
  webFormQuestionId: string;
};
export type webFormFillerUtils_startWebFormSubmissionMutation$variables = {
  input: CreateWebFormSubmissionInput;
};
export type webFormFillerUtils_startWebFormSubmissionMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly id: string;
    } | null;
  };
};
export type webFormFillerUtils_startWebFormSubmissionMutation = {
  response: webFormFillerUtils_startWebFormSubmissionMutation$data;
  variables: webFormFillerUtils_startWebFormSubmissionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateWebFormSubmissionResponse",
    "kind": "LinkedField",
    "name": "createWebFormSubmission",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "WebFormSubmission",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "webFormFillerUtils_startWebFormSubmissionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "webFormFillerUtils_startWebFormSubmissionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9be34382599ca660bdd8b02507cf78b7",
    "id": null,
    "metadata": {},
    "name": "webFormFillerUtils_startWebFormSubmissionMutation",
    "operationKind": "mutation",
    "text": "mutation webFormFillerUtils_startWebFormSubmissionMutation(\n  $input: CreateWebFormSubmissionInput!\n) {\n  response: createWebFormSubmission(input: $input) {\n    node {\n      id\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5ca50e8e581b3841d95d1bc36e26a716";

export default node;
